import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=58100e76&scoped=true&"
import script from "./ProjectStatus.vue?vue&type=script&lang=ts&"
export * from "./ProjectStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectStatus.vue?vue&type=style&index=0&id=58100e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58100e76",
  null
  
)

export default component.exports